import { Component, Input, inject } from '@angular/core';
import { ComponentView } from 'src/modules/app-template/models/component-view.model';
import { MainAppService } from 'src/modules/app-template/services/main-app.service';
import { ObjectOfSimpleDataTypes } from 'src/modules/utils/shared/object-of-simple-data-types.model';
import { GenericObjectDefinition } from '../../models/generic-object-definition.model';
import { RestEndpoint } from '../../models/rest-endpoint.model';
import { TableData } from '../../models/table-data.model';
import { TableColumn } from '../../models/table-column.model';
import { TableCellType } from '../../models/table-cell-type.enum';
import { TableRow } from '../../models/table-row.model';
import { TableSortColumn } from '../../models/table-sort-column.model';
import { FrontendFormDefinition } from '../../models/frontend-form-definition.model';
import { FrontendFieldDefinition } from '../../models/frontend-field-definition.model';
import { FrontendFieldType } from '../../models/frontend-field-type.enum';
import { Utils } from 'src/modules/utils/shared/utils';

@Component({
    selector: 'admin-object-edit',
    templateUrl: './admin-object-edit.component.html',
    styleUrls: ['./admin-object-edit.component.scss']
})
export class AdminObjectEditComponent extends ComponentView {

    app = inject(MainAppService);

    neededParams: ObjectOfSimpleDataTypes = { 
        scope: "string",
        id: "string",
        key: "string"
     };
    
    @Input()
    scope: string;
    @Input()
    id: string;
    @Input()    
    key: string;

    def: GenericObjectDefinition;
    data: any;
    
    form: FrontendFormDefinition;
    
    async initParams(): Promise<boolean> {
        this.def = this.app.mainConfig.genericObjectDefinitions.find(item => item.scope == this.scope && item.id == this.id);
        this.data = await this.app.loadDataHandler(async () => RestEndpoint.main().query({key: this.key}).run(this.def.apiEndpoint).getObject(), this) ?? {};
        this.form = new FrontendFormDefinition([
            //TODO PRAGMATIC
            this.def.id == "locations" ? new FrontendFieldDefinition("label", "Name", FrontendFieldType.text, { enabled: false }) : null,
            ...this.def.attributes
        ]);
        this.form.fill(this.data);

        this.app.updateNavigation(null, [
            { label: "Administration", routerLink: ["/base2", "admin"] },
            { label: this.def.title, routerLink: ["/base2", "admin", "generic-list", this.scope, this.id] },
            { label: this.data?.label, routerLink: ["/base2", "admin", "generic-list", this.scope, this.id, this.key] }
        ]);
        return true;
    }

    async saveInternal(): Promise<void> {
        this.form.get(this.data);
        //TODO PRAGMATIC
        if ("accountingCutOffDate" in this.data) {
            this.data.accountingCutOffDate = Utils.dateToUtc(this.data.accountingCutOffDate);
        }
        await this.app.saveDataHandler(async () => RestEndpoint.main().query({key: this.key}).body(this.data).put().run(this.def.apiEndpoint).getText(), this, true, true);
    }

    cancel(): void {
        this.app.navigateBack();
    }
}
